import { render, staticRenderFns } from "./FormSpinbuttonMinMax.vue?vue&type=template&id=048e2064&"
import script from "./FormSpinbuttonMinMax.vue?vue&type=script&lang=js&"
export * from "./FormSpinbuttonMinMax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports